module.exports = __webpack_public_path__ + "img/works_titleist_a_btm_off_m.e6cef4e1.png";